import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { WebAccessControlSchedulerFormFactory } from '../factory/WebAccessControlSchedulerFormFactory';
import { WebAccessControlSchedulerFormBaseDataProvider } from '../dataProvider/WebAccessControlSchedulerFormBaseDataProvider';
import { ScheduleItem } from '../../webAccessControlSchedulerApp/types';

export class WebAccessControlSchedulerFormRepository extends BaseWebComponentRepository {
  public dataProviderFactory: WebAccessControlSchedulerFormFactory;
  public dataProvider: WebAccessControlSchedulerFormBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new WebAccessControlSchedulerFormFactory(),
    });
  }

  public async createRecords(records: Array<ScheduleItem>) {
    return this.dataProvider.createRecords(records);
  }

  public async updateRecords(records: Array<ScheduleItem>) {
    return this.dataProvider.updateRecords(records);
  }
}
